import { temporarilyNotSupport } from '../../utils'

// 隐私信息授权
export const requirePrivacyAuthorize = /* @__PURE__ */ temporarilyNotSupport('requirePrivacyAuthorize')
export const openPrivacyContract = /* @__PURE__ */ temporarilyNotSupport('openPrivacyContract')
export const onNeedPrivacyAuthorization = /* @__PURE__ */ temporarilyNotSupport('onNeedPrivacyAuthorization')
export const getPrivacySetting = /* @__PURE__ */ temporarilyNotSupport('getPrivacySetting')
